import { useEffect, useState } from 'react';

import { fetchScrf } from 'api/ApiClient';
import useLoading from 'hooks/useLoading';

type Props = { children: JSX.Element };

const CsrfFetcher = ({ children }: Props) => {
	const [isFetched, setIsFetched] = useState<boolean>(false);
	const loading = useLoading();

	const start = () => {
		loading.enable();
	};

	const success = () => {
		loading.disable();
		setIsFetched(true);
	};

	const error = () => {
		loading.disable();
	};

	useEffect(() => {
		start();

		fetchScrf(success, error);
	}, []);

	if (!isFetched) {
		return null;
	}

	return children;
};

export default CsrfFetcher;
